import { render, staticRenderFns } from "./healthInfo.vue?vue&type=template&id=984e2d60&scoped=true&"
import script from "./healthInfo.vue?vue&type=script&lang=js&"
export * from "./healthInfo.vue?vue&type=script&lang=js&"
import style0 from "./healthInfo.vue?vue&type=style&index=0&id=984e2d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984e2d60",
  null
  
)

export default component.exports